<template>
    <div>
        <CustomFieldInputText
            v-if="customField.type === CustomFieldTypeEnum.Text"
            :savedValue="savedValue"
            :customField="customField"
            :errors="errors"
        />
        <CustomFieldInputRadioSelect
            v-if="customField.type === CustomFieldTypeEnum.RadioSelect"
            :savedValue="savedValue"
            :customField="customField"
            :errors="errors"
        />
        <CustomFieldInputNumber
            v-if="customField.type === CustomFieldTypeEnum.Number"
            :savedValue="savedValue"
            :customField="customField"
            :errors="errors"
        />
        <CustomFieldInputSingleCheckbox
            v-if="customField.type === CustomFieldTypeEnum.SingleCheckbox"
            :savedValue="savedValue"
            :customField="customField"
            :errors="errors"
        />
        <CustomFieldInputMultipleCheckbox
            v-if="customField.type === CustomFieldTypeEnum.MultipleCheckbox"
            :savedValue="savedValue"
            :customField="customField"
            :errors="errors"
        />
    </div>
</template>

<script setup lang="ts">
    import { onBeforeMount, type PropType } from 'vue'
    import CustomField from '@/App/CustomField/Entity/CustomField'
    import CustomFieldInputText from '@/BookingForm/BookingForm/Component/CustomField/CustomFieldInputText.vue'
    import CustomFieldInputRadioSelect from '@/BookingForm/BookingForm/Component/CustomField/CustomFieldInputRadioSelect.vue'
    import CustomFieldInputNumber from '@/BookingForm/BookingForm/Component/CustomField/CustomFieldInputNumber.vue'
    import CustomFieldInputSingleCheckbox from '@/BookingForm/BookingForm/Component/CustomField/CustomFieldInputSingleCheckbox.vue'
    import CustomFieldInputMultipleCheckbox from '@/BookingForm/BookingForm/Component/CustomField/CustomFieldInputMultipleCheckbox.vue'
    import {
        CustomFieldTypeEnum,
        type CustomFieldResponseDTO,
    } from '@/Shared/AutoGenerated/Main'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'

    const props = defineProps({
        customField: {
            type: Object as PropType<CustomField>,
            required: true,
        },
        errors: {
            type: Object as PropType<ApiFormErrors>,
            required: true,
        },
        savedValue: {
            type: Object as PropType<CustomFieldResponseDTO>,
            required: true,
        },
    })

    onBeforeMount(() => {
        if (props.customField.id.value !== props.savedValue.customFieldId) {
            throw new Error(
                `Custom field IDs '${props.customField.id.value}' and '${props.savedValue.customFieldId}' do not match.`,
            )
        }

        if (!props.customField.isEnabled) {
            throw new Error(
                `Custom '${props.customField.id.value}' is disabled.`,
            )
        }
    })
</script>
